// Shared media URLs (from references the user already approved)
export const MEDIA = {
  hero_clear: "/hero/original.png",
  hero_frosted: "/hero/frosted_windows_v3.jpg",
  remote:
    "https://media.base44.com/images/public/6a183b86008b66fb533fd478/e36334bd5_remote.png",
  products: {
    standard: "/products/standard_clear.png",
    premium:
      "https://media.base44.com/images/public/6a183b86008b66fb533fd478/808040c92_generated_07675728.png",
    standardReverse: "/products/standard_reverse_clear.png",
    premiumReverse:
      "https://media.base44.com/images/public/6a183b86008b66fb533fd478/6d77945c2_generated_6a80cdf4.png",
  },
  pdlc:
    "https://media.base44.com/images/public/6a183b86008b66fb533fd478/d72a97770_generated_6f78b180.png",
  applications: {
    residential:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/2f42508ee_generated_image.png",
    commercial:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/e032219b3_generated_image.png",
  },
  portfolio: {
    meridian:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/579990a5f_generated_image.png",
    villaSerenita:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/a9d968f9a_generated_image.png",
    yachtPhantom:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/3c649cbdc_generated_image.png",
    penthouse:
      "https://media.base44.com/images/public/6a1810f2191449b35522c6d2/aa019614d_generated_image.png",
  },
};

export const PRODUCTS = [
  {
    id: "standard",
    name: "PrivacyGlass™ Standard",
    tagline: "Frosted → Clear",
    description:
      "Refined, dependable PDLC for everyday privacy. Switches from opaque to clear at a touch.",
    img: MEDIA.products.standard,
    bullets: [
      "Default state: opaque",
      "Switching speed under 150ms",
      "Up to 70% light transmission when clear",
    ],
  },
  {
    id: "premium",
    name: "PrivacyGlass™ Premium",
    tagline: "Frosted → Clear",
    description:
      "Opaque by default. Transforms to crystal-clear transparency at the touch of a switch. The gold standard for architectural privacy.",
    img: MEDIA.products.premium,
    bullets: [
      "Default state: opaque white",
      "Switching speed under 100ms",
      "Up to 75% light transmission when clear",
    ],
  },
];

export const APPLICATIONS = [
  { name: "Residential Villas", note: "Bathrooms, bedrooms, living spaces" },
  { name: "Corporate Offices", note: "Boardrooms & executive suites" },
  { name: "Healthcare", note: "Patient privacy & observation rooms" },
  { name: "Hospitality", note: "Hotels, spas, luxury resorts" },
  { name: "Retail", note: "Storefronts & display partitions" },
  { name: "Automotive & Marine", note: "Sunroofs, yachts, partitions" },
];

export const PORTFOLIO = [
  {
    title: "Meridian Tower",
    type: "Commercial",
    location: "Athens, Greece",
    coverage: "2,400 sq ft",
    img: MEDIA.portfolio.meridian,
  },
  {
    title: "Villa Serenità",
    type: "Residential",
    location: "Santorini, Greece",
    coverage: "860 sq ft",
    img: MEDIA.portfolio.villaSerenita,
  },
  {
    title: "M/Y Phantom",
    type: "Marine",
    location: "Mediterranean Sea",
    coverage: "340 sq ft",
    img: MEDIA.portfolio.yachtPhantom,
  },
  {
    title: "Skyline Penthouse",
    type: "Residential",
    location: "Amalfi Coast, Italy",
    coverage: "1,800 sq ft",
    img: MEDIA.portfolio.penthouse,
  },
];

export const STATS = [
  { value: "<100ms", label: "Switching speed" },
  { value: "99%", label: "UV protection" },
  { value: "65%", label: "Heat rejection" },
  { value: "75%", label: "Light transmission" },
];
